import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function usePersonaIdSubtypesFlag() {
  return useCbhFlag(CbhFeatureFlag.PERSONAL_ID_SUBTYPES, {
    defaultValue: {
      manual: [],
      stripe: [
        "Driver's License",
        "State ID",
        "US Passport",
        "US Passport Card",
        "Military ID",
        "Permanent Resident",
      ],
    },
  });
}
